export enum RexCalculationType {
  CONSTANT = 'constant',
  JSON_LOGIC = 'json_logic',
  JAVASCRIPT = 'javascript',
  LIQUID = 'liquid',
}
